import Menu from './menu';

import '../styles/styles.scss';


window.onload = () => {
    const m = new Menu('burger');
};
